/**
 * Created by nagib on 10/31/2018.
 */
import React from "react";
import { useLocation } from "react-router-dom";
import Toolbar from "@mui/material/Toolbar";
import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";
import ErrorBoundary from "../../../../ErrorBoundary";
import { FooterLinksLeft, FooterLinksRight } from "../FooterLinks";
import classes from "./footer.module.css";

function FooterContent() {
  return (
    <>
      <Grid size={{ sm: 12, md: 12, lg: 6 }}>
        <div className={classes.left}>
          <FooterLinksLeft />
        </div>
      </Grid>
      <Grid size={{ sm: 12, md: 12, lg: 6 }}>
        <div className={classes.right}>
          <FooterLinksRight />
        </div>
      </Grid>
    </>
  );
}

function Footer(props) {
  const { user = null } = props;
  const { pathname } = useLocation();
  return (
    <footer className={classes.main}>
      <Toolbar>
        <Grid
          container
          sx={(theme) => ({
            display: "flex",
            flexDirection: { xs: "column", md: "column", lg: "row" },
            [theme.breakpoints.up("md")]: {
              ml:
                user &&
                !user.addNewUser &&
                !pathname.includes("browser-support")
                  ? "17.8125rem"
                  : 0,
            },
            alignItems: "center",
            "& .MuiTypography-root": {
              my: { xs: "0.5em", md: undefined },
              fontSize: "0.88rem",
            },
            [theme.breakpoints.between("md", "lg")]: {
              "& .MuiGrid-root > div": {
                justifyContent: "center",
              },
            },
          })}
        >
          <ErrorBoundary key="footer" name="footer">
            <FooterContent />
          </ErrorBoundary>
        </Grid>
      </Toolbar>
    </footer>
  );
}
Footer.propTypes = {
  user: PropTypes.shape({
    stateful: PropTypes.bool,
  }),
};
Footer.defaultProps = {
  user: null,
};
export default Footer;
